import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {Router} from '@angular/router';
import {FormDataTrackingService} from '@app/services/analytics/form-data-tracking.service';
import {FallbackActonTypeStrategy} from '@app/shared/action-type-strategy-patern/fallback-action-type-strategy';
import {NavigationActionTypeStrategy} from '@app/shared/action-type-strategy-patern/navigation-action-type-strategy';
import {NewPageActionTypeStrategy} from '@app/shared/action-type-strategy-patern/new-page-action-type-strategy';
import {PageNavigationActionTypeStrategy} from '@app/shared/action-type-strategy-patern/page-navigation-action-type-strategy';
import {PopupActionTypeStrategy} from '@app/shared/action-type-strategy-patern/popup-action-type-strategy';
import {SupportFormActionTypeStrategy} from '@app/shared/action-type-strategy-patern/support-form-action-type-strategy';
import {DcpSupportFormService} from '@app/shared/support-form/dcp-support-form.service';
import {ActionTypeContext, DcpBundleTemplate, TransactionListCta, TransactionType} from '@dcp/configurator';
import {Product} from '@spartacus/core';
import {LaunchDialogService} from '@spartacus/storefront';
import {CustomScrollingService} from '../custom-scrolling.service';

@Injectable({
  providedIn: 'root',
})
export class ActionTypeSelectStrategyService {
  public actionTypeContext: ActionTypeContext;

  constructor(
    @Inject(PLATFORM_ID) public platformId: object,
    public formDataTrackingService: FormDataTrackingService,
    private customScrollingService: CustomScrollingService,
    private router: Router,
    private dcpSupportFormService: DcpSupportFormService,
    private launchDialogService: LaunchDialogService
  ) {}

  public selectStrategy(
    transactionType: TransactionType,
    product: Product,
    cta: TransactionListCta,
    bundleTemplate: DcpBundleTemplate
  ): ActionTypeContext {
    switch (transactionType.actionType) {
      case 'new page':
        this.actionTypeContext = new ActionTypeContext(new NewPageActionTypeStrategy(this.platformId, cta));
        break;
      case 'navigation':
        this.actionTypeContext = new ActionTypeContext(
          new NavigationActionTypeStrategy(this.platformId, cta, this.router)
        );
        break;
      case 'pageNavigation':
        this.actionTypeContext = new ActionTypeContext(
          new PageNavigationActionTypeStrategy(this.customScrollingService)
        );
        break;
      case 'popup':
        this.actionTypeContext = new ActionTypeContext(
          new PopupActionTypeStrategy(
            this.launchDialogService,
            this.formDataTrackingService,
            transactionType,
            cta,
            product,
            bundleTemplate
          )
        );
        break;
      case 'supportForm':
        this.actionTypeContext = new ActionTypeContext(
          new SupportFormActionTypeStrategy(this.dcpSupportFormService, cta)
        );
        break;
      default:
        this.actionTypeContext = new ActionTypeContext(new FallbackActonTypeStrategy());
    }
    return this.actionTypeContext;
  }
}
